// Back to top button JS for Regular Challenge
import $ from 'jquery'

$(window).on('scroll', function()  {
  var $toTopButton = $('.to-top-button');
  var footerHeight = $('.w-flexible-footer').height()

  // Showing and Hiding toTopButton
  if ( $(window).scrollTop() > ($(window).height() / 2) ) {
    $toTopButton.show()
  } else {
    $toTopButton.hide()
  }

  // Preventing button positionin further then content block
  if ($(window).width() > 1023) {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - footerHeight) {
      $toTopButton.css('position','absolute');
    } else {
      $toTopButton.css('position','fixed');
    }
  } else {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - footerHeight) {
      $toTopButton.css('position','absolute');
    } else {
      $toTopButton.css('position','fixed');
    }
  }

  // Getting page to the top after click
  $toTopButton.on('click', function(e) {
    e.preventDefault();
    $('html,body').stop(true, false).animate({ scrollTop: 0 }, "slow");
    return false;
  });
})
